import * as stylex from '@stylexjs/stylex';
export const styles = {
  container: {
    maxWidth: "xf2d64e",
    marginInline: "xvueqy4",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    paddingTop: "xf6mfmo",
    paddingInline: "xnxx81d",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    textAlign: "x2b8uid",
    $$css: true
  },
  button: {
    marginTop: "xj1urod",
    $$css: true
  }
};